import { ExpandableGroupService } from '@commons/am-expandable-group/expandable-group.service';
import { DisneyTicketComboComponent } from '@commons/disney-ticket-combo/disney-ticket-combo.component';
import { IncrementInputComponent } from '@commons/increment-input/increment-input.component';
import { AmExpandableInputComponent } from '@commons/am-expandable-input/am-expandable-input.component';
import { CardInfoDetailV2Component } from '@commons/card-info-detail-v2/card-info-detail-v2.component';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, registerLocaleData } from '@angular/common';
import { AmTripsAddProductModule } from '@am/trips-add-product';
import { AmRewardsPricingComponent } from '@am/rewards-pricing';
import PT from '@angular/common/locales/pt';
// Upgrade directives
import {
  BackgroundImageDirective,
  DeferLoadDirective,
  OnCreateDirective,
  StopPropagationDirective,
} from './directives';

// Pipes
import {
  CurrencyPipe,
  EllipsisPipe,
  IsEconomicPipe,
} from './pipes';

// Components commons
import { SearchStatusComponent } from '@commons/search-status/search-status.component';
import { OutstandingPromoComponent } from '@commons/outstanding-promo/outstanding-promo.component';
import { ModifySearchComponent } from '@commons/modify-search/modify-search.component';
import { LegalTaxesComponent } from '@commons/legal-taxes/legal-taxes.component';
import { BreadCrumbComponent } from '@commons/breadcrumb/breadcrumb.component';
import { LoaderDetailComponent } from '@commons/loader-detail/loader-detail.component';
import { SliderComponent } from '@commons/slider/slider.component';
import { AmenitiesComponent } from '@commons/amenities/amenities.component';
import { AvuxiComponent } from '@commons/avuxi/avuxi.component';
import { SearchWidgetComponent } from '@commons/search-widget/search-widget.component';
import { CustomBannerComponent } from '@commons/custom-banner/custom-banner.component';
import { RelatedHotelsComponent } from '@commons/related-hotels/related-hotels.component';
import { UsersViewsComponent } from '../containers/detail/components/users-views/users-views.component';
import { TagsComponent } from '@commons/tags/tags.component';
import { AlertContentComponent } from '@commons/alert-content/alert-content.component';
import { ProviderInfoComponent } from '@commons/provider-info/provider-info.component';
import { VerticalSliderComponent } from '@commons/vertical-slider/vertical-slider.component';
import { AmExpertsShareComponent } from '@am/experts-share';
import { AmExpertsCompensationComponent } from '@am/experts-compensation';
import {
  MbAccelerator,
  MbAdvice,
  MbAlert,
  MbBadge,
  MbBreadcrumbs,
  MbButton,
  MbCard,
  MbCarousel,
  MbCommunication,
  MbDatepicker,
  MbDialog,
  MbDialogBody,
  MbDialogFooter,
  MbDialogHeader,
  MbExpandablePanel,
  MbExpandableText,
  MbFormField,
  MbIcon,
  MbIconText,
  MbPopoverTrigger,
  MbProgressBar,
  MbRecommendedCard,
  MbReviewsRating,
  MbStarsRating,
  MbTooltipContent,
  MbTooltipTrigger,
} from '@am/moebius';
import { ProviderDialogComponent } from '@commons/provider-dialog/provider-dialog.component';
import { ButtonDisneyComponent } from '@commons/button-disney/button-disney.component';
import { FocusSelectComponent } from '@commons/focus-select/focus-select.component';
import { DisneySelectedPlanComponent } from '../containers/tickets/components/disney-selected-plan/disney-selected-plan.component';
import { MealPlanDisneyComponent } from '../containers/detail/disney/meal-plan/meal-plan.component';
import { PriceComponent } from '@commons/price/price.component';
import { PricingExpandableComponent } from '@commons/price/pricing-expandable/pricing-expandable.component';
import { AmExpandableGroupComponent } from '@commons/am-expandable-group/am-expandable-group.component';
import { DisneyBenefitsComponent } from '../containers/detail/disney/disney-benefits/disney-benefits.component';
import { BasicSkeletonComponent } from '@commons/basic-skeleton/basic-skeleton.component';
import { ProgressBarComponent } from '@commons/progress-bar/progress-bar.component';
import { SearchBoxComponent } from '@am/search-box';
import { CustomTooltipDirective } from './pipes/custom-tooltip.directive';

registerLocaleData(PT, 'pt-BR');



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AmRewardsPricingComponent,
    AmTripsAddProductModule,
    AmExpertsShareComponent,
    AmExpertsCompensationComponent,
    MbAdvice,
    MbFormField,
    MbButton,
    MbAlert,
    MbBreadcrumbs,
    MbCard,
    MbIcon,
    MbExpandableText,
    MbStarsRating,
    MbReviewsRating,
    MbCommunication,
    MbAccelerator,
    MbDialogHeader,
    MbDialogBody,
    MbDialogFooter,
    MbBadge,
    MbRecommendedCard,
    MbCarousel,
    ReactiveFormsModule,
    MbPopoverTrigger,
    MbDatepicker,
    MbIconText,
    MbTooltipContent,
    MbExpandablePanel,
    MbProgressBar,
    SearchBoxComponent,
    CustomTooltipDirective,
    DeferLoadDirective,
    StopPropagationDirective,
    OnCreateDirective,
    BackgroundImageDirective,
    SearchStatusComponent,
    SearchWidgetComponent,
    OutstandingPromoComponent,
    ModifySearchComponent,
    LegalTaxesComponent,
    BreadCrumbComponent,
    CustomBannerComponent,
    RelatedHotelsComponent,
    LoaderDetailComponent,
    SliderComponent,
    AmenitiesComponent,
    AvuxiComponent,
    UsersViewsComponent,
    TagsComponent,
    AlertContentComponent,
    CurrencyPipe,
    IsEconomicPipe,
    EllipsisPipe,
    ProviderInfoComponent,
    ProviderDialogComponent,
    ButtonDisneyComponent,
    AmExpandableInputComponent,
    IncrementInputComponent,
    DisneyTicketComboComponent,
    CardInfoDetailV2Component,
    VerticalSliderComponent,
    FocusSelectComponent,
    DisneySelectedPlanComponent,
    MealPlanDisneyComponent,
    PriceComponent,
    PricingExpandableComponent,
    AmExpandableGroupComponent,
    DisneyBenefitsComponent,
    BasicSkeletonComponent,
    ProgressBarComponent,
  ],
  declarations: [],
  exports: [
    CustomTooltipDirective,
    DeferLoadDirective,
    StopPropagationDirective,
    OnCreateDirective,
    BackgroundImageDirective,
    SearchStatusComponent,
    SearchWidgetComponent,
    OutstandingPromoComponent,
    ModifySearchComponent,
    LegalTaxesComponent,
    BreadCrumbComponent,
    CustomBannerComponent,
    RelatedHotelsComponent,
    LoaderDetailComponent,
    SliderComponent,
    AmenitiesComponent,
    AvuxiComponent,
    UsersViewsComponent,
    TagsComponent,
    AlertContentComponent,
    ProviderInfoComponent,
    ProviderDialogComponent,
    CurrencyPipe,
    IsEconomicPipe,
    ButtonDisneyComponent,
    AmExpandableInputComponent,
    DisneyTicketComboComponent,
    CardInfoDetailV2Component,
    FocusSelectComponent,
    DisneySelectedPlanComponent,
    PriceComponent,
    PricingExpandableComponent,
    AmExpandableGroupComponent,
    DisneyBenefitsComponent,
    BasicSkeletonComponent,
    EllipsisPipe,
    ProgressBarComponent,
  ],
  providers: [ExpandableGroupService],
})
export class SharedModule { }
